import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export async function getRecurringSchedules() {
  try {
    const response = await api.get("merchant/recurring-slot-schedule", null);
    return Array.isArray(response) ? response : response?.content ?? [];
  } catch (error) {
    console.error(error);
    throw new Error("Recurring schedules could not be loaded");
  }
}

export async function createRecurringSchedule(payload) {
  try {
    const response = await api.create("merchant/recurring-slot-schedule", payload);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error(error?.response?.data?.message || "Schedule could not be created");
  }
}

export async function updateRecurringSchedule(id, payload) {
  try {
    const response = await api.update("merchant/recurring-slot-schedule/" + id, payload);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error(error?.response?.data?.message || "Schedule could not be updated");
  }
}

export async function deleteRecurringSchedule(id) {
  try {
    await api.delete("merchant/recurring-slot-schedule/" + id, null);
  } catch (error) {
    console.error(error);
    throw new Error("Schedule could not be deleted");
  }
}
